import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import axios from 'axios';
import { post } from '../../../Services/api';

const CheckoutForm = ({ user_data, selectedPlan, selectedPaymentMethod, trial_days }) => {
    const current_env = process.env.NODE_ENV
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        try {
            if (!stripe || !elements) {
                // Stripe.js hasn't yet loaded.
                // Make sure to disable form submission until Stripe.js has loaded.
                return;
            }

            let confirmSetup
            // If no payment method existed then create
            if (!selectedPaymentMethod)
                confirmSetup = await stripe.confirmSetup({
                    //`Elements` instance that was used to create the Payment Element
                    elements,
                    redirect: "if_required"
                })

            const subscription = await post("/api/billing/stripe/monthly-subscription", {
                price_id: selectedPlan.price_id,
                user_email: user_data.email,
                payment_method: selectedPaymentMethod ? selectedPaymentMethod : confirmSetup.setupIntent.payment_method, // If previous payment method selected
                payment_plan_id: selectedPlan.payment_plan_id,
                trial_days: trial_days ? trial_days : null
            })
            window.location.reload();
        } catch (error) {
            console.log(error)
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            {!selectedPaymentMethod ? <PaymentElement /> : null}
            <button disabled={!stripe} className='checkout_form_pay cursor_pointer font_size_16'>Pay</button>
            {/* Show error message to your customers */}
            {errorMessage && <div>{errorMessage}</div>}
        </form>
    )
};

export default CheckoutForm;